var _style, _defs, _path, _defs2, _defs3, _defs4, _path2, _defs5, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcpTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000183933003002970597580000016466155152640677545_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#DCF4F7;}\r\n\t.st2{clip-path:url(#SVGID_00000078740949539721659340000014502806196819494552_);}\r\n\t.st3{clip-path:url(#SVGID_00000115501694166433073750000017655031277940643505_);}\r\n\t.st4{fill:url(#SVGID_00000180365220220245601380000007505184092818091946_);}\r\n\t.st5{clip-path:url(#SVGID_00000023247226158470050940000013661217846972251056_);}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#37ABC8;}\r\n\t.st7{clip-path:url(#SVGID_00000071540064782715220120000001908948962180343486_);}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#69C9D2;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 30.9,
    y: 47.5,
    width: 404,
    height: 406.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089572723820438429230000009391678938411445135_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000089572723820438429230000009391678938411445135_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.2,250.7c0,3.3-0.1,6.7-0.2,9.9c-0.1,3.3-0.4,6.5-0.7,9.9c-0.4,3.3-0.7,6.5-1.2,9.8s-1.1,6.5-1.7,9.8 c-0.6,3.3-1.3,6.4-2.2,9.7c-0.8,3.3-1.7,6.4-2.7,9.6c-1,3.1-1.9,6.3-3.1,9.4c-1.1,3.1-2.3,6.2-3.5,9.2s-2.5,6-4,9.1 c-1.5,3-2.9,5.9-4.5,8.8c-1.6,2.9-3.1,5.8-4.8,8.6c-1.7,2.8-3.5,5.6-5.3,8.3c-1.8,2.8-3.8,5.4-5.7,8.1c-1.9,2.7-4,5.2-6,7.9 c-2.1,2.5-4.2,5.1-6.4,7.5s-4.5,4.8-6.8,7.1s-4.7,4.6-7.1,6.8c-2.4,2.2-5,4.4-7.5,6.4c-2.5,2.1-5.2,4.1-7.7,6 c-2.7,1.9-5.3,3.9-8.1,5.7s-5.6,3.6-8.3,5.3c-2.8,1.7-5.7,3.3-8.6,4.8c-2.9,1.6-5.8,3-8.8,4.5c-3,1.5-6,2.8-9.1,4 c-3,1.2-6.2,2.4-9.2,3.5c-3.1,1.1-6.3,2.2-9.4,3.1c-3.1,1-6.3,1.8-9.6,2.7c-3.1,0.8-6.4,1.6-9.7,2.2c-3.3,0.6-6.5,1.2-9.8,1.7 c-3.3,0.5-6.5,0.8-9.8,1.2c-3.3,0.4-6.5,0.6-9.9,0.7c-3.3,0.1-6.5,0.2-9.9,0.2c-3.3,0-6.5-0.1-9.9-0.2c-3.3-0.1-6.5-0.4-9.9-0.7 c-3.3-0.4-6.5-0.7-9.8-1.2c-3.3-0.5-6.5-1.1-9.8-1.7c-3.3-0.6-6.4-1.3-9.7-2.2c-3.1-0.8-6.4-1.7-9.6-2.7c-3.1-1-6.3-1.9-9.4-3.1 c-3.1-1.1-6.2-2.3-9.2-3.5s-6-2.7-9.1-4c-3-1.5-5.9-2.9-8.8-4.5c-2.9-1.6-5.8-3.1-8.6-4.8c-2.8-1.7-5.6-3.5-8.3-5.3 s-5.4-3.8-8.1-5.7c-2.7-1.9-5.2-4-7.7-6c-2.5-2.1-5.1-4.2-7.5-6.4s-4.8-4.5-7.1-6.8c-2.3-2.3-4.6-4.7-6.8-7.1 c-2.2-2.4-4.4-5-6.4-7.5c-2.1-2.5-4.1-5.2-6-7.9c-1.9-2.7-3.9-5.3-5.7-8.1c-1.8-2.8-3.6-5.6-5.3-8.3c-1.7-2.8-3.3-5.7-4.8-8.6 c-1.6-2.9-3-5.8-4.5-8.8c-1.5-3-2.8-6-4-9.1s-2.4-6.2-3.5-9.2c-1.1-3.1-2.2-6.3-3.1-9.4c-1-3.1-1.8-6.3-2.7-9.6 c-0.8-3.1-1.6-6.4-2.2-9.7c-0.6-3.3-1.2-6.5-1.7-9.8c-0.5-3.3-0.8-6.5-1.2-9.8c-0.4-3.3-0.6-6.5-0.7-9.9 c-0.1-3.3-0.2-6.7-0.2-9.9s0.1-6.7,0.2-9.9s0.4-6.5,0.7-9.9c0.4-3.3,0.7-6.5,1.2-9.8c0.5-3.3,1.1-6.5,1.7-9.8 c0.6-3.3,1.3-6.4,2.2-9.7c0.8-3.1,1.7-6.4,2.7-9.6c1-3.1,1.9-6.3,3.1-9.4c1.1-3.1,2.3-6.2,3.5-9.2c1.2-3,2.5-6,4-9.1 c1.5-3,2.9-5.9,4.5-8.8c1.6-2.9,3.1-5.8,4.8-8.6c1.7-2.8,3.5-5.6,5.3-8.3c1.8-2.8,3.8-5.4,5.7-8.1c1.9-2.7,4-5.2,6-7.7 c2.1-2.5,4.2-5.1,6.4-7.5s4.5-4.8,6.8-7.1c2.3-2.3,4.7-4.6,7.1-6.8c2.4-2.2,5-4.4,7.5-6.4c2.5-2.1,5.2-4.1,7.7-6 c2.7-1.9,5.3-3.9,8.1-5.7c2.8-1.8,5.6-3.6,8.3-5.3c2.8-1.7,5.7-3.4,8.6-4.8c2.9-1.6,5.8-3,8.8-4.5s6-2.8,9.1-4 c3-1.2,6.2-2.4,9.2-3.5c3.1-1.1,6.3-2.2,9.4-3.1c3.1-1,6.3-1.8,9.6-2.7c3.1-0.8,6.4-1.6,9.7-2.2c3.3-0.6,6.5-1.2,9.8-1.7 c3.3-0.5,6.5-0.8,9.8-1.2c3.3-0.4,6.5-0.6,9.9-0.7c3.3-0.1,6.5-0.2,9.9-0.2c3.3,0,6.5,0.1,9.9,0.2c3.3,0.1,6.5,0.4,9.9,0.7 c3.3,0.4,6.5,0.7,9.8,1.2c3.3,0.5,6.5,1.1,9.8,1.7c3.3,0.6,6.4,1.3,9.7,2.2c3.1,0.8,6.4,1.7,9.6,2.7c3.1,1,6.3,2.1,9.4,3.1 c3.1,1.1,6.2,2.3,9.2,3.5c3,1.2,6,2.7,9.1,4c3,1.5,5.9,2.9,8.8,4.5c2.9,1.6,5.8,3.1,8.6,4.8c2.8,1.7,5.6,3.5,8.3,5.3 c2.8,1.8,5.4,3.8,8.1,5.7c2.7,1.9,5.2,4,7.7,6c2.5,2.1,5.1,4.2,7.5,6.4s4.8,4.5,7.1,6.8s4.6,4.7,6.8,7.1c2.2,2.4,4.4,5,6.4,7.5 c2.1,2.5,4.1,5.2,6,7.7c1.9,2.7,3.9,5.3,5.7,8.1c1.8,2.8,3.6,5.6,5.3,8.3c1.7,2.8,3.3,5.7,4.8,8.6c1.6,2.9,3,5.8,4.5,8.8 c1.5,3,2.8,6,4,9.1c1.2,3,2.4,6.2,3.5,9.2c1.1,3.1,2.2,6.3,3.1,9.4c1,3.1,1.8,6.3,2.7,9.6c0.8,3.1,1.6,6.4,2.2,9.7 c0.6,3.3,1.2,6.5,1.7,9.8c0.5,3.3,0.8,6.5,1.2,9.8c0.4,3.3,0.6,6.5,0.7,9.9C434.1,244,434.2,247.3,434.2,250.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000115484467970083157750000002071542253071027646_",
    x: 34,
    y: 49,
    width: 400,
    height: 400
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027599242741402171850000004393491279231532180_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115484467970083157750000002071542253071027646_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027599242741402171850000004393491279231532180_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170999562115962482130000017539400041833216918_",
    d: "M217.9,446.5c-12.6-1.5-27.3-4.4-28.1-5.6 c-0.5-0.7,1.6-1.8,4.5-2.3c7-1.3,7.1-1.3,17.9,0c6.2,0.7,9.7,0.5,10.4-0.7c0.8-1.3,3-1.1,7.6,0.8c5.8,2.3,10.4,2.4,18,0.5 c1.5-0.4,2.3,0.2,1.9,1.6c-0.4,1.6,0.4,1.9,2.4,1c1.6-0.7,5.2-1.1,7.9-1l5,0.2l-8-5.6l3.8-1.5c2.4-0.8,4.6-0.7,6,0.5 c2.9,2.4,23.2,0.7,31.5-2.7c3.3-1.3,8.2-2.5,11-2.5c2.8,0,7-1.1,9.3-2.4c4.6-2.7,8.2-3.1,8.2-1.2c0,1.5-16.2,8.7-30.5,13.7 C277.7,446,242,449.2,217.9,446.5L217.9,446.5z M261.9,420c-5.9-2.4-9.2-8.3-6.5-11.6c1.2-1.5,1-2.1-0.6-2.1s-1.7-0.4-0.4-1.2 c1.1-0.7,2.4-5,3-9.4c0.6-4.6,2.1-11.6,3.3-15.7s2.2-9,2.2-10.8c0-3.5,1.5-14.5,3.1-23.7c1.3-7.4-1.9-13.1-9.8-17.1 c-3.5-1.8-6.8-4.5-7.3-6c-2.4-7.7-8.1-19.2-12.7-25.6c-4.5-6.3-1.5-19.7,5.9-26.3c4.5-4,5.2-5.7,4.7-10.9 c-0.2-3.4-1.1-6.5-1.8-7c-0.7-0.5-1.5-1.6-1.5-2.4c-0.1-1-1.1-1.7-2.2-1.7c-1.1,0-1.9,1-1.7,2.1c0.5,2.7-9.4,0.8-12.5-2.3 c-1.2-1.2-2.9-2.2-3.8-2.2c-0.8,0-1.6-1-1.6-2.2c0-3.5-7-9-13.2-10.2c-3.1-0.6-7.4-2.7-9.4-4.5c-2.4-2.2-6.4-3.5-12-3.8 c-8.6-0.5-17.4-4.7-15.7-7.5c0.5-0.8-1.2-1.6-4-1.6c-6.2,0-8.1-2.8-4.1-5.9c1.7-1.3,2.3-2.2,1.2-1.9c-1.5,0.4-7.9-6-12.6-12.8 c-0.6-1-3.4-4.2-6.2-7.4l-5-5.8l2.5,5.3c1.5,2.9,3.3,5.3,4.1,5.3c0.8,0,1.1,1.1,0.6,2.3c-0.5,1.3-0.1,2.8,0.8,3.4 s1.8,2.3,1.8,3.8c0,2.3-0.4,2.3-3.3-0.4c-1.8-1.7-3.3-4-3.3-5.2c0-1.2-1.1-2.7-2.5-3.3c-1.6-0.6-2.2-2.2-1.6-4 c0.5-1.6,0.1-3.4-0.7-4c-0.8-0.6-1.7-2.4-1.7-4s-1.8-5-4-7.3c-6-6.5-7.7-17.2-4.1-26.1c3.3-8.2,4-14.8,1.5-14.8 c-1,0-1.2-1.7-0.7-4c0.5-2.2,0.2-4.5-0.8-5.1c-1-0.6-1.8,0-1.8,1.5c0,1.5-0.7,2.5-1.7,2.5s-1.6-1.7-1.5-3.8 c0.6-7-0.2-9.6-3.1-9.6c-3.8,0-15.4,5.9-17.1,8.7c-0.7,1.1-1.8,2.1-2.5,2.1s-4.7,2.4-9,5.3c-4.2,2.9-8.1,4.8-8.6,4.4 c-0.5-0.5,1.5-2.5,4.4-4.6c2.9-1.9,5.6-5.1,5.8-6.8c0.4-1.8,3.3-5.7,6.7-8.6c3.3-2.9,4.6-4.8,2.9-4.2 c-4.7,1.7-2.5-3.1,2.7-5.7c2.3-1.1,4.7-3.8,5.2-5.8c1.3-5,12.7-12.8,18.6-12.8c2.5,0,9.2-1,14.6-2.2c5.4-1.2,12.6-1.9,16-1.7 c5,0.4,6-0.1,5.8-2.5c-0.2-2.4-0.7-2.7-3.1-1.2c-1.6,1-3.4,1.3-4,0.7c-1.6-1.6,2.5-6.2,5.4-6.2c1.5,0,2.1-1,1.6-2.3 c-0.6-1.6,1.2-3.3,5.2-5.1c3.4-1.5,4.6-2.3,2.8-1.9c-4.4,1-14.2,4.5-17.7,6.2c-1.6,0.8-4.4,1.5-6.2,1.5 c-1.8,0-3.3,0.6-3.3,1.5c0,1.5-11.7,6.2-19.8,8c-3.6,0.8-3.4,0.4,1.7-3c17.9-12.3,33.8-19.1,58.2-24.8 c12.6-2.9,20.3-3.6,44.9-3.6c29.6,0,51.8,2.7,46.9,5.7c-1.2,0.7-2.8,1-3.6,0.5c-0.7-0.5-9.1-1.1-18.5-1.3 c-14.4-0.4-16.9-0.1-16.2,1.9c0.5,1.3,1.8,2.1,3,1.6c2.8-1.1,16.2,5.9,24.8,12.9c3.9,3.3,7.7,5.8,8.5,5.8 c0.7,0,2.3,1.6,3.5,3.4c1.9,3,1.7,3.5-1.1,4.2c-4.2,1.1-5.4,7.9-2.7,15.6c1.2,3.4,1.8,6.5,1.3,7c-1.5,1.5-11.3-4.5-17.7-10.8 c-3.5-3.5-7.1-5.8-8.1-5.2c-1,0.6-1.3,0.4-0.7-0.6c0.6-1-0.1-2.7-1.5-3.9c-1.5-1.2-2.2-3.1-1.7-4.4c0.5-1.2-0.2-2.2-1.6-2.2 c-1.3,0-2.9-1.1-3.4-2.5c-0.5-1.3-1.7-2.4-2.7-2.4s-2.9-1.1-4.5-2.4c-1.9-1.8-4-2.1-7.5-1c-2.7,0.8-3.9,1.6-2.7,1.6 c3.5,0.2,15.4,13.2,14.9,16.3c-0.2,1.6,0,3.6,0.6,4.6c0.6,1,0.4,2.8-0.4,4.1c-1.3,2.1-2.5,1.8-8.6-1.3 c-3.9-2.1-8.3-3.8-9.8-3.8c-3.8,0-5.4-3.1-2.4-4.2c1.3-0.5,2.9-2.1,3.4-3.4c0.7-1.8,0.1-2.2-2.3-1.5c-2.4,0.7-3.3,0.2-3.3-1.8 c0-1.6-0.5-2.4-1.1-1.8c-0.6,0.6-1.9,0.4-2.9-0.4c-1.2-1.1-1.8,0.2-1.8,4.2c0,3.8,1,6.3,2.9,7.4c1.6,0.8,2.5,2.2,2.2,2.9 c-0.4,0.7,1.2,1,3.6,0.6c3-0.5,6.9,1,11.9,4.4c5.7,3.9,7.5,4.5,8,2.7c0.8-3.8,2.3-3,9.4,4.2c3.5,3.6,7.1,6.4,8.1,6 c1.8-0.6,6.2,3.4,10.2,9.4c2.8,4.2,6.8,6,4.8,2.2c-0.6-1.1,0.5-0.4,2.4,1.8c1.9,2.2,3.4,5.1,3.4,6.7c0,2.3-0.2,2.4-1.6,0.2 c-1.5-2.2-1.6-2.2-1.7,0c-0.1,1.7-0.4,1.8-1,0.4c-1.3-3.3-8.5-2.5-8.2,0.8c0.1,1.8-1.1,3-3.5,3.4c-2.1,0.2-3.8,1.3-3.8,2.3 c0,1.1-2.5,1.5-6.7,0.8c-5.4-0.7-6.7-0.4-6.7,1.8c0,1.5-1.5,4.6-3.3,6.9c-1.8,2.3-3.3,5.2-3.3,6.4c0,1.9-0.5,1.9-2.9,0 c-2.7-2.1-2.7-1.9,0.1,2.3c3.3,5.1,2.7,6.8-4.1,12.5c-4.6,3.9-6.2,10.6-2.9,12.7c2.4,1.5,5.1,9,3.9,10.9 c-1.5,2.3-5.8-1.8-8.3-7.9c-1.6-3.8-3.6-5.4-7.4-6.2c-8.1-1.6-11.4-1.2-11.4,1.3c0,1.5-1.2,2.1-3.3,1.5 c-3.8-1-13.8,4.7-17.4,9.9c-3.1,4.6-3.1,10,0.1,16.9c3,6.4,5.4,7.6,12.3,6.3c3.4-0.7,5.2-2.2,5.9-5c0.5-2.2,1.8-4,2.9-4 c1.1-0.1,3.1-0.4,4.7-0.7c4.4-0.8,5,1.7,2.1,7.5c-1.5,2.8-2.3,5.6-1.7,6c0.5,0.5,0.1,1.9-1,3.3c-1.6,1.9-0.8,2.2,4.4,1.6 c10.2-1.1,12.2,0,12.1,7c-0.1,11.9,3.6,16.8,10.3,13.2c2.2-1.2,4.2-1.2,6.4,0c4.2,2.3,4.5,2.2,8.1-1.7c1.7-1.8,4.5-3.6,6.3-4 c1.7-0.4,4.6-1.2,6.3-1.9c2.2-0.8,2.8-0.7,1.9,0.7c-0.6,1.1-0.4,1.9,0.6,1.9s1.7-0.7,1.7-1.6c0-0.8,1.9-0.5,4.5,0.7 c2.4,1.2,5.2,1.8,6,1.3c0.8-0.6,1.1-0.2,0.6,0.7c-0.6,1,0.6,2.2,2.7,2.7c5.2,1.5,6.5,1.3,5.4-0.5c-0.5-0.8-0.1-2.1,1-2.8 c1.2-0.7,1.5-0.5,0.7,0.7c-1.1,1.8,1.2,2.5,6.9,2.3c1.1,0,2.1,1.1,2.1,2.7c0,3.8,11.3,12.7,17.7,13.9 c6.4,1.2,12.1,5.8,12.1,9.7c0,1.6,0.8,3.4,1.8,3.9c1.1,0.7,0.7,2.3-1.2,4.6c-1.6,1.9-1.9,2.7-0.6,1.5c1.9-1.7,4.4-1,12.8,3.8 c5.8,3.1,11.9,5.8,13.4,5.8c1.6,0,4.2,1.5,5.9,3.1c1.6,1.7,3.9,2.8,5.2,2.3c1.7-0.6,2.3,0.5,2.3,4.1c0,3.5-2.2,7.5-7.4,13.5 c-4,4.7-7.9,10.9-8.5,13.8c-1.7,7.9-9.1,17.3-15.1,19.2c-2.9,1-5.3,2.9-5.3,4.1c0,1.3-2.1,3.6-4.6,5.2 c-2.5,1.6-5.9,4.6-7.5,6.7c-8.1,10-16.9,17.1-20.6,16.5c-2.9-0.5-3.6,0-3.3,2.2c0.5,3-3,8.3-5.6,8.3c-0.8,0-5.6,3.5-10.5,7.7 c-5.9,5.2-8.3,8.1-7,9c1.3,0.8,0.7,2.3-2.1,4.6c-3.8,3.1-3.9,3.5-1.1,5.7c1.6,1.2,2.9,2.7,2.9,3.1 C273.2,422,266.9,422.1,261.9,420L261.9,420z M255.3,135.9c-1.2-0.5-2.7-0.4-3.1,0.1c-0.6,0.6,0.5,1,2.2,0.8 C256.3,136.7,256.6,136.4,255.3,135.9z M266.5,128.4c0-0.6-1.1-0.7-2.4-0.2c-1.5,0.6-2.5,0-2.5-1.3c0-1.8-0.2-1.8-1.5,0.1 c-0.8,1.5-0.7,3.9,0.4,6.3l1.8,4l2.1-3.9C265.5,131.3,266.5,129,266.5,128.4z M213.8,133c0-0.4-1.7-1.7-3.8-3 c-3.4-2.2-4.1-2.2-7.1,0.2c-3.3,2.7-3.3,2.8,3.8,3C210.5,133.5,213.8,133.3,213.8,133z M209.8,124.5c-3-2.2-3-2.3-0.1-3.4 c1.7-0.6,5.8-0.4,9.2,0.5c5.2,1.5,6,1.3,5.2-0.8c-0.6-1.6-0.2-2.1,1-1.3c1.1,0.6,3.3,0.5,4.8-0.5c2.7-1.6,2.5-1.7-0.6-1.7 c-2.7,0-3.5-1.1-3.5-4.5c0-2.4-1.5-5.4-3.1-6.7c-1.7-1.2-2.9-2.7-2.7-3c1.1-2.1,0.1-4.1-2.1-4.1c-1.3,0-2.4-0.8-2.4-1.8 c0-1-1-1.5-2.1-1.1c-1.1,0.4-3.4,0.1-5-0.7c-2.3-1.2-3.9-0.4-7.1,3.5c-2.3,2.8-4.8,4.7-5.6,4.2c-0.7-0.5-1.7,0.2-2.3,1.6 c-0.5,1.3-0.4,2.3,0.2,2.1c0.6-0.2,3.3,1.7,5.8,4.4c2.9,2.9,5.6,4.2,7.3,3.6c3.4-1.3,9.1,0.5,7.9,2.5 c-0.5,0.8-2.1,1.6-3.4,1.6c-1.5,0-1.9-0.8-1.3-1.9c0.7-1.2,0.5-1.5-0.7-0.7c-1.1,0.6-1.5,1.9-1,2.8c0.5,0.8,0.1,1.6-0.8,1.6 s-1.7-0.7-1.7-1.7c0-2.9-6.2-1.8-7,1.3c-1,3.5,2.9,7.9,4.6,5.2c0.7-1.2,1.7-1.2,3.1,0c1.1,1,2.5,1.2,3.1,0.6s1.1-0.1,1.1,1.1 s0.6,1.7,1.2,1C212.3,127.4,211.5,125.7,209.8,124.5z M222,115.6c0-0.8,0.7-2.1,1.6-2.5c1-0.6,1.2,0.1,0.6,1.6 C223.2,117.5,222,118,222,115.6z M201.3,111.4c-1.8-1.3-2.3-2.4-1.3-2.4c3.1-0.1,7.1,1.8,7.1,3.4 C207.1,114.6,205,114.2,201.3,111.4z M256.6,127.5c0-0.2-1.5-1.1-3.1-2.1c-2.2-1.2-3.6-1.1-4.8,0.4c-1.2,1.6-0.5,2.1,3.1,2.1 C254.6,127.9,256.6,127.8,256.6,127.5L256.6,127.5z M231.9,123.8c0-1-1.2-1.7-2.5-1.7c-1.5,0-2.1,0.7-1.6,1.7 c0.6,1,1.7,1.7,2.5,1.7C231.2,125.5,231.9,124.6,231.9,123.8z M237.8,123.8c-0.6-1-1.3-1.7-1.7-1.7c-0.4,0-0.7,0.7-0.7,1.7 c0,1,0.8,1.7,1.7,1.7C238,125.5,238.2,124.6,237.8,123.8z M184,115.4c-2.1-1.5-1.8-2.3,2.1-5.7c2.5-2.2,4.6-5,4.6-6 c0-1.1-1.1-0.6-2.3,1.2c-1.3,1.8-2.9,2.7-3.6,1.9c-0.7-0.7-0.4-1.2,0.7-1.2s1.9-1.1,1.9-2.4c0-3.3-3.1-3.3-4.4,0 c-0.5,1.3-1.6,2.1-2.4,1.6c-0.8-0.5-1.1-1.6-0.6-2.4s0.2-1.6-0.7-1.6s-2.2,0.7-2.7,1.7c-0.6,1-1.8,1.2-2.8,0.6 c-1.1-0.7-1-1.6,0.5-2.4c1.8-1.2,1.8-1.5-0.2-1.3c-3.1,0-11.5,4.7-8.6,4.8c1.2,0,1.7,0.7,1.2,1.6s0.7,1.1,2.8,0.7l3.8-0.7 l-3.8,2.3l-3.8,2.3l4.6,2.1c3.3,1.5,4.7,1.6,5.2,0.2c0.5-1.3,1.3-1.3,3,0.1c1.9,1.6,1.9,2.3,0.2,3.4c-1.5,0.8-0.4,1.3,2.8,1.3 C185.5,117.1,186,116.8,184,115.4z M177.9,109.5c-2.3-2.5-0.7-3,2.7-0.8c1.2,0.7,1.6,1.8,0.8,2.3 C180.7,111.4,179,110.8,177.9,109.5z M242.6,109.1c-1-1-4.1,1.5-4.1,3.3c0,0.8,1.1,0.6,2.3-0.5 C242.1,110.7,243,109.5,242.6,109.1z M195.7,111.6c0-0.4-1.2-1.1-2.5-1.6c-1.5-0.6-2.2-0.2-1.6,0.6 C192.5,112.2,195.7,112.9,195.7,111.6z M170.5,94.8c1.5-1.2,0.6-1.7-2.9-1.6c-2.7,0.1-6.3,1.6-7.9,3.3 c-2.8,3.1-2.8,3.1,0.6,0.2c3.6-3,6.7-1.3,4.7,2.7c-0.6,1.1,0,1,1.2-0.4C167.6,97.7,169.5,95.7,170.5,94.8z M184,97.3 c0-1-0.7-1.3-1.7-0.7c-1,0.6-1.7,1.3-1.7,1.7c0,0.4,0.7,0.7,1.7,0.7C183.3,99,184,98.3,184,97.3z M175.5,84.6 c-1.6-0.4-3.9-0.4-5,0.1c-1.1,0.5,0.2,0.8,2.9,0.7C176.1,85.4,177,85.1,175.5,84.6z M188.3,82.8c-0.5-0.5-1.8,0-2.9,1.1 c-1.6,1.6-1.5,1.8,1,1C187.9,84.2,188.8,83.3,188.3,82.8z M207.1,80.7c0-0.8-0.6-1.6-1.3-1.6c-0.7,0-1.3,1.1-1.3,2.4 s0.6,2.1,1.3,1.6C206.5,82.7,207.1,81.6,207.1,80.7z M200.6,77.5c-1-1.8-1.2-4.2-0.6-5.3c0.7-1.3,0.1-1.2-1.6,0.2 c-2.7,2.2-2.7,2.5-0.1,5.3C201.9,81.8,202.8,81.7,200.6,77.5z M192.3,78.5c-0.4-0.4-2.9-1.1-5.7-1.7c-3.6-0.8-4.2-0.6-2.4,0.6 C186.3,78.9,193.8,80,192.3,78.5z M177.5,74.1c2.2-1.6,2.2-1.7,0-1c-1.3,0.4-4,0-5.8-1c-2.9-1.6-3-1.5-1.1,1.1 C173.3,76.4,174.1,76.5,177.5,74.1z M185.7,71.8c0-1.6-1-2.1-2.7-1.5c-2.1,0.8-2.2,1.3-0.4,2.4 C185.6,74.7,185.7,74.6,185.7,71.8z M229.3,70.9c6.5,0-0.1-3.6-7.3-4c-4.4-0.2-7.7-1.5-9-3.1c-2.9-4-4.1-3.4-4.1,2.1 c0,4,0.6,4.6,3.1,4c1.8-0.5,4.8,0.4,6.9,1.8c2.4,1.7,4.4,2.1,5.3,1C225.3,71.6,227.5,70.9,229.3,70.9z M192.4,70.9 c0-1-0.8-1.7-1.7-1.7c-1,0-1.3,0.7-0.7,1.7c0.6,1,1.3,1.7,1.7,1.7C192,72.6,192.4,71.8,192.4,70.9z M237.1,55 c-1.2-0.5-2.7-0.4-3.1,0.1c-0.5,0.5,0.5,1,2.2,0.8C238.1,55.8,238.5,55.4,237.1,55z M280.9,416.8c-1.8-1.8,0.5-3.9,4.1-3.9 c2.8,0,3,0.4,1.3,2.4C284.2,418,282.6,418.5,280.9,416.8z M104.1,376.6c-4.6-5.3-8.6-9.3-9-9c-0.4,0.4-2.4-1.8-4.6-4.7 c-4-5.4-9.6-9.3-13.4-9.4c-1.2,0-1.7,0.6-1.2,1.6c0.6,1-1,0.8-4-0.1c-3.9-1.3-6-4.1-10.2-12.7c-8.3-17.7-8.5-18.1-4.6-20.2 c1.9-1.1,3-2.8,2.4-4.1c-0.5-1.3-0.2-2.3,0.7-2.3c0.8,0,1.6-1.2,1.6-2.5c0-1.7,1.2-2.4,3.8-2.1c2.5,0.4,3.8-0.4,3.8-2.3 c0-1.6,0.6-3.3,1.2-4c0.7-0.7,1.2-0.4,1.2,0.6s2.2,2.3,5,2.9c2.7,0.6,5,2.1,5,3.1s2.1,3.1,4.6,4.4c2.5,1.2,5,2.5,5.4,2.8 c0.5,0.2,0.6-2.2,0.2-5.3c-0.8-7.1,2.3-7.9,3.8-0.8c0.6,2.7,1.7,5,2.5,5c0.7,0,2.3,2.8,3.4,6.2c1.1,3.4,3.6,7.7,5.4,9.8 c5,5.1,7.6,8.5,7.6,9.9c0,0.6,1.2,2.4,2.7,4.1c3.5,3.9,4.2,16.2,1.3,20.4c-1.2,1.8-2.3,4.6-2.3,6.2c0,1.7-1.7,3.4-4.2,4 c-4.1,1.1-4.1,1.1-0.8,3.4s4.6,5.6,2.2,5.3C112.9,386.3,108.7,381.9,104.1,376.6z M117,350.8c-0.5-1.5-1.3-2.2-1.8-1.8 c-0.5,0.5-0.2,1.6,0.2,2.5C117.3,354.2,118.1,353.7,117,350.8z M132.3,383.3c-1-1.6,11.6-8.3,15.7-8.5c1.9,0,1.9-0.2-0.1-1.6 c-1.9-1.2-2.1-1.6-0.2-1.6c1.7,0,1.9-1.5,1.3-5c-0.6-2.8-0.2-5,0.6-5c0.8,0,1.6,0.7,1.6,1.7s1.6,3.3,3.5,5.1l3.5,3.5l-3.9,2.8 c-2.2,1.5-4.2,2.8-4.7,2.8s-3.1,1.7-6,3.8C138,385,133.8,385.8,132.3,383.3z M148.1,343.1c-1.1-1.1-1.9-2.5-1.9-3.3 c0-2.4,2.5-1.3,4.6,1.9C153,345.4,151.3,346.2,148.1,343.1z M407.6,341.4c0.6-2.1,1.9-11.9,2.7-21.9 c0.8-10.8,2.5-20.1,4.1-22.7c2.2-3.9,2.3-5.9,0.6-12.7c-1.1-4.5-1.5-11.1-0.8-14.8c1-6,0.8-6.7-2.3-6.7 c-1.9,0-3.4-1.1-3.4-2.5c0-3.1-3.1-3.1-7.4,0.1c-1.8,1.3-4.5,2.1-6.2,1.5c-1.6-0.5-4.4-0.1-6,0.7c-4.1,2.2-11.3-3.1-14.5-10.9 c-1.2-3-3.3-5.3-4.4-5.1c-1.5,0.2-2.1-2.8-2.1-10.6c0-6,0.6-10.6,1.3-10.2c0.7,0.5,1.1-1.7,1-4.7c-0.2-3,1.1-8.1,2.8-11.3 c1.7-3.1,3.1-6.9,3.1-8.2c0-1.3,0.7-2.4,1.7-2.3c2.3,0.4,11.1-6.2,10-7.3c-0.5-0.5,0.2-2.3,1.8-4c1.5-1.7,2.2-3,1.5-3 c-0.7,0-0.2-1.3,1-2.9c2.1-2.7,1.9-2.7-0.6-0.6c-1.6,1.2-3,1.8-3.1,1.2c-0.1-0.6-0.4-1.9-0.5-3.1c-0.1-1.1-1.6-1.8-3.4-1.6 c-2.8,0.5-2.9-0.1-1.9-5.8c0.7-3.5,1.1-8.1,1.1-10.2c-0.2-6,1.3-7,6.5-4.4c4.5,2.3,4.8,2.3,4.8-0.5c0-1.7-1.8-5.6-4.1-8.6 c-5-6.7-5-6.8-1.2-5.6c2.7,0.8,2.7,0.7,0.2-1.3c-2.9-2.4-3-2.8-3.4-8.3c-0.1-2.8-0.4-3-1-0.8c-0.4,1.6-1.7,2.9-2.9,2.9 c-3,0-4.5-6.7-1.7-7.6c1.2-0.5,1.8-1.9,1.3-3.3c-0.6-1.7-0.1-2.1,2.1-1.2c2.3,0.8,2.7,0.5,1.8-1.7c-0.7-1.8-0.5-2.4,0.6-1.8 c1,0.6,1.3,2.2,0.8,3.5c-0.5,1.3,1,5.7,3.1,9.7c2.2,4,3.8,8.6,3.3,10.2c-0.5,1.7,0,1.3,1.1-0.7c1.6-3,1.2-4.6-1.8-9.6 c-2.1-3.3-3.4-6.3-3-6.7c1-1,10.6,12.8,12,17.2c0.6,1.9,1.7,3.5,2.3,3.5c2.5,0,20.1,39,20.1,44.6c0,1.5-1.2,1-3.4-1.3 c-3-3.3-6.5-4.8-6.5-2.9c0,1.1,6.9,12.5,7.5,12.5c0.4,0,0.1-1.2-0.5-2.7c-0.8-2.2-0.5-2.4,1.9-1c1.7,1,3.1,3.1,3.4,4.7 s0.8,5.3,1.3,8c0.6,2.8,2.2,12.6,3.5,21.9c2.7,18.3,1.3,41.9-3.4,62.8c-1.3,5.7-2.3,12.7-2.3,15.7c0,9.1-3.3,18.1-6.8,19.1 c-1.8,0.5-5.1,4.5-7.4,9C408.2,345.4,405.5,347.8,407.6,341.4z M418.6,182.8c-1.2-1.2-1.9-1.3-1.9-0.2c0,2.2,1.9,4.1,3,3 C420.2,185.2,419.7,183.9,418.6,182.8z M414.4,182.8c-1.3-6.3-7-16.1-9.3-16.1c-3,0-7.1,6.9-6.2,10.2c0.4,1.2,2.2,2.3,3.9,2.4 c8.6,0.5,10.6,0.8,10.4,1.9c-0.2,1.9,0.1,3.8,0.8,3.8C414.5,184.9,414.6,183.9,414.4,182.8z M182.5,334.3 c0-1.5,0.8-2.3,1.9-1.9c3,1,3.5,4.6,0.6,4.6C183.7,336.9,182.5,335.7,182.5,334.3z M188.3,332c-0.6-1,0.1-1.7,1.6-1.7 c2.9,0,3.4,1,1.1,2.4C190,333.2,188.9,332.8,188.3,332z M153.7,327.5c-1.3-3.6,0.5-5.3,2.4-2.2c1.9,3.1,2.1,5,0.1,5 C155.5,330.3,154.3,329.1,153.7,327.5z M139.5,310.4c0-0.8-1.1-1.2-2.4-0.6c-3,1.2-3.3-1.7-0.4-4c1.6-1.3,2.5-0.7,4,2.3 c1.1,2.2,1.2,4,0.4,4C140.3,312.1,139.5,311.4,139.5,310.4z M107.3,308.4c-1.8-1-4.2-3.1-5.4-4.8c-2.3-3.3-6.9-4.1-6.9-1.3 c0,1-1.5,1.7-3.3,1.7c-1.8,0-3.3-0.7-3.3-1.7s-1.5-1.7-3.3-1.7c-1.8,0-3.3-0.7-3.3-1.7s0.7-1.7,1.7-1.7c3.3,0-2.3-6.3-7.9-9 c-3.8-1.8-5.3-3.5-4.7-5.1c0.6-1.5,0-2.4-1.5-2.4c-1.5,0-2.1,1-1.5,2.4c0.7,1.8-0.2,2.4-3.3,2.4c-2.3,0-4.7-0.7-5.2-1.7 c-0.6-1,0.5-1.7,2.4-1.7c1.8,0,3.5-0.7,3.6-1.7c0.1-1,0.2-2.3,0.4-3.1c0.4-2.4,2.7-4.2,2.7-1.9c0,1.1,0.6,1.6,1.5,1.1 s2.4,0.2,3.5,1.6c1.1,1.3,1.5,2.4,0.7,2.4c-0.7,0-0.5,0.8,0.6,1.9c1.5,1.5,2.5,1.5,4.4-0.1c1.9-1.6,4-1.2,10.5,2.1 c4.5,2.3,9.1,5.3,10.3,6.7c1.2,1.5,4.2,2.7,6.7,2.7c4.6,0,9.2-3.5,7.1-5.6c-0.6-0.6-0.2-1.1,0.7-1.1c3.5,0,3.9,3.3,0.6,6.8 c-2.2,2.3-4.4,3.1-6.5,2.4c-5.8-1.8-6.2,2.7-0.6,7.5C113.3,308.9,113,311.4,107.3,308.4z M127.1,303.5c-0.7-1.2-0.2-1.6,1.3-1 c1.5,0.5,3.3,0.2,4.2-0.7c1.1-1.1,2.1-1.1,2.8,0.1c0.6,1,0.8,1.8,0.6,1.9C130.7,305.2,127.9,305.1,127.1,303.5z M52.8,298.6 c-0.8-1.2-3.4-3.6-5.9-5.2c-6.3-4-8.7-8.8-5.1-10.2c1.6-0.6,2.3-0.5,1.6,0.1c-1.7,1.7,3.9,7.4,5.9,6.2c1-0.6,1.2-0.2,0.5,0.8 c-0.7,1.1,0.5,2.3,3,2.9c4.5,1.1,5,1.9,2.7,5.4C54.4,300.5,54,300.5,52.8,298.6z M58.1,298.2c0.5-1.3,2.1-2.8,3.4-3.3 c1.8-0.7,2.3-0.2,1.6,1.7c-0.6,1.5-1,2.9-1,3.4c0,0.4-1.1,0.7-2.4,0.7C58.2,300.5,57.5,299.6,58.1,298.2z M121.4,297.3 c-2.2-4.1-0.4-4.1,5,0c4.1,3.1,4.1,3.3,0.5,3.3C124.9,300.5,122.3,299.1,121.4,297.3z M68.6,296.5c0-0.4,0.7-1.2,1.7-1.7 c1-0.6,1.7-0.2,1.7,0.7s-0.7,1.7-1.7,1.7S68.6,296.9,68.6,296.5z M74.6,294.1c-0.7-1.2-0.8-2.5-0.2-3.1 c1.5-1.5,3.1,0.7,2.3,3.1C76,295.8,75.5,295.8,74.6,294.1z M51.6,287.9c-0.6-0.6-1.2-4.6-1.3-8.7c-0.1-6.4-0.4-6.8-1.2-2.7 c-0.6,2.7-1.6,4.7-2.3,4.6c-0.7-0.1-1.9-0.4-2.7-0.4c-3.4,0-3.5-11.3-0.4-19.2c3.1-7.9,3.6-7.7,4.2,1.2 c0.5,6.3,2.4,8.5,6.8,7.6c2.5-0.5,3.9,0,3.9,1.5c0,1.2-1.7,2.3-3.8,2.3l-3.8,0.1l3.8,1.5c2.1,0.8,3.8,2.4,3.6,3.6 c0,1.6-0.4,1.6-1.5-0.1c-0.7-1.2-1.8-1.6-2.3-0.7c-0.5,0.8-0.2,2.5,0.6,3.9c0.8,1.3,1.5,3.5,1.5,4.8c-0.1,1.9-0.2,1.9-1,0.2 c-0.6-1.6-1.2-1.7-2.1-0.4C53.3,288.2,52.2,288.5,51.6,287.9z M215.7,282.4c0.8-2.5,3.5-2.8,4.2-0.4c0.4,1.1-0.6,2.1-2.1,2.1 C216.5,284.1,215.4,283.2,215.7,282.4z M77,280c-0.1-1.7,0.4-2.7,0.8-2.2c0.5,0.5,0.6,1.9,0.1,3.1 C77.5,282.4,77.1,281.9,77,280z M36.3,270.4c-1.9-15.5-1.9-16.2-0.6-16.9c0.6-0.4,1.7,3.9,2.3,9.6c0.6,5.7,1.6,12,2.1,14 c0.5,2.1,0.1,3.8-0.7,3.8C38.4,280.7,37.1,276.1,36.3,270.4z M61.9,280.3c-1.2-4.2-1.2-8.7,0.1-10.9c1.2-2.1,1.6-1.1,1.7,4.2 c0,3.9-0.4,7-0.7,7C62.6,280.7,62,280.6,61.9,280.3z M136.3,266.7c0-1.3-1.8-3.4-4.1-4.4c-3.6-1.7-5.7-4.6-3.3-4.6 c1.6,0,8.2,4.1,9.4,5.8c1.8,2.4,1.6,5.8-0.4,5.8C137,269.2,136.3,268,136.3,266.7z M53.8,255.9c-1.2-2.3-1.2-3.3,0-3.3 c1,0,1.7-1.2,1.7-2.5c0-1.5,0.7-2.2,1.7-1.6c2.2,1.3,2.2,10.8,0,10.8C56.3,259.3,54.7,257.7,53.8,255.9z M45.5,250.7 c0-1.2,0.7-3.3,1.6-4.6c1.3-2.1,1.6-1.8,1.6,1.1c0,1.9-0.7,4.1-1.6,4.6C46.3,252.3,45.5,251.9,45.5,250.7z M35.5,245.6 c-0.6-16.5,5.2-54.3,8.6-55.5c0.8-0.2,1.6-2.2,1.6-4.2c0-4.5,7.6-24.1,10.6-27.1c1.7-1.8,2.3-1.7,3.1,0.5 c0.6,1.7,0.4,2.3-0.7,1.6c-1.2-0.7-1.5,0-0.7,2.3c0.7,2.3,0,4.4-2.2,6.4c-3.5,3.3-6.8,10.5-6.8,15c0,2.3,0.4,2.2,2.4-0.5 c1.3-1.8,2.4-5.2,2.4-7.7c0-2.5,0.8-4.6,1.7-4.6c3,0,1.7,11.4-2.1,18.5c-3.1,6-3.8,6.5-4.2,3.4c-0.2-2.1-1.1-3.8-1.8-3.8 c-3.3,0-4.8,20.4-1.7,22.3c2.8,1.7,2.1,8-0.8,6.9c-3.6-1.5-5.3,3.4-5.4,15.5c-0.2,16.3-0.2,16.6-1.9,16.6 C36.3,250.9,35.5,248.5,35.5,245.6z M50.9,245.4c0.5-2.7,0.1-3.8-1.2-3.3c-2.7,1-4.8-12.5-2.5-14.9c1.2-1.2,1.7-0.2,1.7,3 c0,2.9,1.7,6.5,4.4,9.3c3.6,3.9,4,5,2.3,7.1C52.3,250.6,50,249.8,50.9,245.4z M244.8,217.7c1.6-1.6,2.4-1.6,4,0 c1.6,1.6,1.1,1.9-1.9,1.9C243.7,219.6,243.3,219.1,244.8,217.7z M255.1,217.8c0-1.1,1.1-1.5,2.3-1c1.3,0.5,2.8-0.2,3.3-1.6 c0.6-1.5,1.8-1.9,3-1.2c1.1,0.7,3.6,1.1,5.7,0.8c1.9-0.2,4,0.4,4.6,1.3c0.6,1-0.2,1.8-1.9,1.8c-1.7,0-6.2,0.5-10,1 C257.3,219.5,255.1,219.1,255.1,217.8z M277.8,217.7c1.6-1.6,2.4-1.6,4,0c1.6,1.6,1.1,1.9-1.9,1.9 C276.8,219.6,276.2,219.1,277.8,217.7z M239.7,208.7c-2.5-1.3-5.4-1.9-6.4-1.3c-1.1,0.7-1.5,0.4-0.7-0.7 c0.7-1.2-0.1-1.9-2.3-1.9c-1.9,0-3.1,0.6-2.7,1.3c0.5,0.7-0.6,1.3-2.4,1.3c-4.4,0-4-2.3,0.8-4.5c3.3-1.5,5.9-1.1,14,2.1 c9.9,3.9,12.8,6.4,7.1,6.3C245.6,211.2,242.2,210,239.7,208.7z M387,186.7c0-1,0.7-1.7,1.7-1.7s1.7,0.4,1.7,0.7 c0,0.4-0.7,1.2-1.7,1.7C387.8,187.9,387,187.7,387,186.7z M390.3,156.1c0-0.4,0.7-1.2,1.7-1.7c1-0.6,1.7-0.2,1.7,0.7 c0,1-0.7,1.7-1.7,1.7S390.3,156.4,390.3,156.1z M63.7,147.9c0-1.3,0.7-2.9,1.7-3.5c1-0.6,1.7,0.1,1.7,1.5 c0,1.3-0.7,2.9-1.7,3.5C64.4,149.9,63.7,149.3,63.7,147.9z M70.3,147.9c0-0.4,0.7-1.2,1.7-1.7c1-0.6,1.7-0.2,1.7,0.7 s-0.7,1.7-1.7,1.7C71.1,148.6,70.3,148.2,70.3,147.9z M80.1,138.8c0-1,0.7-1.7,1.7-1.7c1,0,1.7,0.4,1.7,0.7 c0,0.4-0.7,1.2-1.7,1.7C81,140,80.1,139.8,80.1,138.8z M82.7,123.7c-0.6-0.8-1.9-1.1-3-0.5c-1.1,0.7-1,0,0.4-1.6 c2.3-2.9,7.6-3.8,9.1-1.5c0.5,0.7-0.6,2.2-2.3,3.3C84.7,124.6,83.3,124.8,82.7,123.7z M300.7,100.4c-1.7-1-4.1-1.3-5.4-0.8 c-1.3,0.5-2.1,0.2-1.5-0.7c0.6-0.8,0.1-1.6-1-1.6c-3.6,0,0.1-2.2,4.6-2.7c5.1-0.6,14.3,3.8,12.9,6 C309,102.7,304.5,102.6,300.7,100.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149365493295894734350000014380872819498415279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170999562115962482130000017539400041833216918_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000149365493295894734350000014380872819498415279_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000039125367814540459130000007918719909027453065_",
    cx: -141.7563,
    cy: 583.3049,
    r: 346.7672,
    gradientTransform: "matrix(1.3364 0 0 1.3303 230.459 -761.9717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#37ABC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    style: {
      stopColor: "#37AAC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    style: {
      stopColor: "#37AAC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    style: {
      stopColor: "#37AAC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    style: {
      stopColor: "#37A9C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    style: {
      stopColor: "#37A9C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    style: {
      stopColor: "#37A9C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    style: {
      stopColor: "#37A8C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09765621,
    style: {
      stopColor: "#37A8C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1094,
    style: {
      stopColor: "#37A7C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    style: {
      stopColor: "#37A7C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    style: {
      stopColor: "#37A7C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#37A6C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1562,
    style: {
      stopColor: "#37A6BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#37A6BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    style: {
      stopColor: "#37A5BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    style: {
      stopColor: "#37A5BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    style: {
      stopColor: "#37A4BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    style: {
      stopColor: "#37A4BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2266,
    style: {
      stopColor: "#37A4BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    style: {
      stopColor: "#37A3BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#37A3BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    style: {
      stopColor: "#37A3BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2695,
    style: {
      stopColor: "#37A2BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2773,
    style: {
      stopColor: "#37A2B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2852,
    style: {
      stopColor: "#37A2B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#37A2B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3008,
    style: {
      stopColor: "#37A1B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    style: {
      stopColor: "#37A1B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3164,
    style: {
      stopColor: "#37A1B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3242,
    style: {
      stopColor: "#37A1B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#37A0B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    style: {
      stopColor: "#37A0B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3477,
    style: {
      stopColor: "#37A0B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3555,
    style: {
      stopColor: "#37A0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3633,
    style: {
      stopColor: "#379FB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3711,
    style: {
      stopColor: "#379FB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#379FB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3945,
    style: {
      stopColor: "#379EB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4102,
    style: {
      stopColor: "#379EB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4258,
    style: {
      stopColor: "#379DB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4414,
    style: {
      stopColor: "#379DB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    style: {
      stopColor: "#379CB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    style: {
      stopColor: "#379CAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    style: {
      stopColor: "#379BAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5039,
    style: {
      stopColor: "#379BAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    style: {
      stopColor: "#379AAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5273,
    style: {
      stopColor: "#379AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#379AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5508,
    style: {
      stopColor: "#3799AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    style: {
      stopColor: "#3699AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5742,
    style: {
      stopColor: "#3698AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    style: {
      stopColor: "#3698A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5977,
    style: {
      stopColor: "#3698A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6094,
    style: {
      stopColor: "#3697A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    style: {
      stopColor: "#3697A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6328,
    style: {
      stopColor: "#3697A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    style: {
      stopColor: "#3696A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6484,
    style: {
      stopColor: "#3696A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6562,
    style: {
      stopColor: "#3696A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6641,
    style: {
      stopColor: "#3696A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    style: {
      stopColor: "#3695A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6797,
    style: {
      stopColor: "#3695A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    style: {
      stopColor: "#3695A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6953,
    style: {
      stopColor: "#3695A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7109,
    style: {
      stopColor: "#3694A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    style: {
      stopColor: "#3694A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7422,
    style: {
      stopColor: "#3693A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7578,
    style: {
      stopColor: "#3693A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7695,
    style: {
      stopColor: "#3692A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7812,
    style: {
      stopColor: "#36929F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    style: {
      stopColor: "#36919E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8047,
    style: {
      stopColor: "#36919E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8164,
    style: {
      stopColor: "#36919D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#36909D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#36909C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8398,
    style: {
      stopColor: "#36909C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    style: {
      stopColor: "#36909B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8633,
    style: {
      stopColor: "#368F9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    style: {
      stopColor: "#368F9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8906,
    style: {
      stopColor: "#368E99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    style: {
      stopColor: "#368E99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    style: {
      stopColor: "#368E98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9219,
    style: {
      stopColor: "#368D98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9297,
    style: {
      stopColor: "#368D97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    style: {
      stopColor: "#368D96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    style: {
      stopColor: "#368C96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9648,
    style: {
      stopColor: "#368C95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9805,
    style: {
      stopColor: "#368B95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9883,
    style: {
      stopColor: "#368B94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#368B94"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039125367814540459130000007918719909027453065_)"
    },
    d: "M34.4,50.5v398.8h400.5V50.5H34.4z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000171687862533909146580000004803132390822600078_",
    x: 230.9,
    y: 7.1,
    width: 220.5,
    height: 474.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060024517408012458080000014164320318310675077_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171687862533909146580000004803132390822600078_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060024517408012458080000014164320318310675077_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M396.8,441.6c20.3,7,38.2,16.9,54.1,29.9C419.4,301.9,216.6,114.4,303.7,33.3c2.3-2.2,9.4-6.5,12.1-8.5 c-7.5-10.3-16.3-15.7-23.1-17.8c-2.1,0.6-4,1.5-6,2.3c-52.1,23.5-62.9,93.6-49.1,143.7c24.6,90,110.2,194.9,121.1,327.8 C381,452.6,393.7,439.4,396.8,441.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000088115182161889074130000005270933030604348602_",
    x: 46.1,
    y: 3.9,
    width: 350.9,
    height: 495.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004543141499604292180000010033211860663914675_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088115182161889074130000005270933030604348602_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004543141499604292180000010033211860663914675_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M291.5,7.4c2.2-0.7,4.4-1.3,6.7-1.8c18.4-3.6,35.7,0,50.4,8.5c102.6,58.8,17.3,246.1-34,311.3 C232.2,422.1,156.5,480.2,87.3,499c13.4-31.7,19.4-48.5,17.8-50.1l-58.8-14.4c141.4-59,337.5-215.7,276.8-380.8 C317.3,38.5,306.8,14.9,291.5,7.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcpTransparent);
export default __webpack_public_path__ + "static/media/CCP_transparent.4a6aedc86ee6dfc3786388bcfadeaf0f.svg";
export { ForwardRef as ReactComponent };